import GetData from 'apps/frontend/services/GetData';
import { requests } from 'apps/frontend/services/Requests';
import { GetMetaData } from 'apps/frontend/services/StaticData';
import RecordNotFound from 'apps/frontend/components/Shared/RecordNotFound/RecordNotFound';
import Rerouting from 'apps/frontend/components/Shared/RecordNotFound/Rerouting';
import { removeSlot } from 'apps/frontend/lib/dfp';
import { DefineSlotsInnerPage } from 'apps/frontend/lib/dfp/util';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import SkeletonLoader from 'apps/frontend/components/Shared/SkeletonLoader/SkeletoLoader';
import VideoNewsLayout from 'apps/frontend/components/NewsLayout/VideoNewsLayout/VideoNewsLayout';
import ArticleNewsLayout from 'apps/frontend/components/NewsLayout/ArticleNewsLayout/ArticleNewsLayout';
import { buildNewsRoute } from 'apps/frontend/services/Util';
import {
  getUserLocation,
  saveUserLocation,
  showUserLocation,
} from 'apps/frontend/services/getUserLocation';

const Index = (props: any) => {
  const { news, metaData } = props;
  const router = useRouter();
  const [specialCategories, setSpecialCatgories] = useState<any[]>([]);
  const [urlok, setUrlok] = useState(true);

  useEffect(() => {
    DefineSlotsInnerPage();
    return () => {
      router.events.off('routeChangeComplete', removeSlot);
    };
  }, []);

  useEffect(() => {
    const sponsoredCategories = news?.categories?.filter(
      (item) => item?.isSponsoredCategory == true
    );
    setSpecialCatgories(sponsoredCategories);

    if (sponsoredCategories?.length > 0) {
      router.push('/sector/news/' + router.query.id + '/' + router.query.slug);
    }
    const location = { 'city': props.city, 'country': props.country };
    if (typeof window !== 'undefined') {
      localStorage.setItem('userLocation', JSON.stringify(location));
    }
  }, [props]);

  return Object.keys(news).length > 0 ? (
    <>
      {urlok == false ? (
        <Rerouting />
      ) : (
        <>
          {specialCategories?.length > 0 ? (
            <div className="container">
              <SkeletonLoader count={30} />
            </div>
          ) : news?.contentType == 'VIDEO' ? (
            <VideoNewsLayout news={news} metaData={metaData} />
          ) : (
            <ArticleNewsLayout news={news} metaData={metaData} />
          )}
        </>
      )}
    </>
  ) : (
    <RecordNotFound />
  );
};

// const validateUrlObject = (urlObj, monthFromTime, dayFromTime) => {
//   const { id, year, day, month, slug } = urlObj;
//   // console.log('urlObj==>', urlObj, monthFromTime);
//   if (!id || !/^\d+$/.test(id)) return false;
//   if (!year || !/^\d{4}$/.test(year)) return false;
//   if (!slug || typeof slug !== 'string') return false;

//   const isValidDateFormat = (d, m) => {
//     // console.log('validDay==>', d, 'validMonth', m);
//     const validDay = /^\d{2}$/.test(d) && Number(d) >= 1 && Number(d) <= 12;
//     const validMonth = /^\d{2}$/.test(m) && Number(m) >= 1 && Number(m) <= 31;
//     return validDay && validMonth;
//   };

//   if (day !== monthFromTime) return false;

//   if (!isValidDateFormat(day, month)) return false;

//   return true;
// };

const validateUrlObject = (urlObj, monthFromTime, dayFromTime) => {
  const { id, year, day, month, slug } = urlObj;

  if (!id || !/^\d+$/.test(id)) return false;
  if (!year || !/^\d{4}$/.test(year)) return false;
  if (!slug || typeof slug !== 'string') return false;

  const validDay =
    /^\d{2}$/.test(day) && Number(day) >= 1 && Number(day) <= 31;

  const validMonth =
    /^\d{2}$/.test(month) && Number(month) >= 1 && Number(month) <= 12;

  if (!validDay || !validMonth) return false;

  if (day !== dayFromTime) return false;
  if (month !== monthFromTime) return false;

  return true;
};

export async function getServerSideProps(context) {
  const resPost = await GetData(
    `${requests.NewsById + context.params.id}`,
    {},
    'get',
    false
  );

  const geo = await getUserLocation(context.req);

  const newsRes = resPost?.data?.response?.news
    ? resPost?.data?.response?.news
    : {};

  // console.log('newsRes=>>', newsRes.createdAt);
  const time = newsRes?.createdAt;
  const date = new Date(time);
  const dayFromTime = date.getDate().toString().padStart(2, '0');
  const monthFromTime = (date.getMonth() + 1).toString().padStart(2, '0');

  const urlObject = {
    id: context.params.id,
    year: context.params.year,
    day: context.params.day,
    month: context.params.month,
    slug: context.params.slug,
  };

  const isValid = validateUrlObject(urlObject, monthFromTime, dayFromTime);
  // console.log('isValid==>', isValid);

  const image =
    newsRes?.contentType == 'VIDEO' ? newsRes?.thumbnail : newsRes?.image;
  const routePath = buildNewsRoute(
    newsRes?.id,
    newsRes?.createdAt,
    newsRes?.seoDetail?.slugLine,
    newsRes?.title
  );

  if (isValid == false) {
    return {
      redirect: {
        destination: `/${encodeURI(routePath)}`,
        permanent: true,
      },
    };
  }

  const seoData = {
    ...newsRes?.seoDetail,
    image: image,
    id: context.params.id,
    route: routePath,
    postTitle: newsRes?.title,
  };

  // console.log('SEO--------------------------->>', seoData);

  const metaData = GetMetaData(seoData);

  return {
    props: {
      metaData: metaData,
      news: newsRes,
      country: geo?.country || 'Unknown',
      city: geo?.city || 'Unknown',
    },
  };
}

export default Index;
